<div fxLayout="row" fxLayout.lt-md="column">
  <mat-card fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card-content>
      <form [formGroup]="rangeForm" (ngSubmit)="onSubmit()" class="basic-form">
        <div fxLayout="row wrap" fxFlexAlign="center" class="row">
          <mat-form-field fxFlex="100" class="p-10">
            <mat-label>Name</mat-label>
            <input type="text" matInput formControlName="name" placeholder="Premium">
            <mat-error *ngIf="form.name.hasError('required')">
              Name is <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayoutAlign="end center" fxLayoutGap="15px" *ngIf="selectedRange && canBeEdited(selectedRange)">
          <button type="submit" class="add-action-button" mat-flat-button color="primary"
            [disabled]="!rangeForm.valid || rangeName === form?.name?.value">
            <mat-icon>done</mat-icon>Save
          </button>
          <button type="button" class="reset-button" mat-stroked-button color="basic" (click)="showProductsView()">
            <mat-icon>clear</mat-icon> Cancel
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<div *ngIf="!isAddMode" class="analytics" fxLayout="row" fxLayout.lt-md="column">
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content id="inRangeContainer" cdkDropList [cdkDropListData]="inRange" (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="outRangeContainer">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label><span class="text-info">{{ getProducts(true) }}</span> Products in your <strong>{{ rangeName }}</strong> range</label>
          <label>
            <span *ngIf="shareMode && canBeEdited(selectedRange)" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px" class="text-warning ifc-link" matTooltip="Build Range" (click)="toggleShareMode()">Build <mat-icon>group_work</mat-icon></span>
            <span *ngIf="!shareMode" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px" class="text-success ifc-link" matTooltip="Share Range" (click)="toggleShareMode()">Share <mat-icon>share</mat-icon></span>
          </label>
        </div>
        <mat-card *ngIf="!shareMode" [class.banner-incomplete]="!isRangeModified" [class.banner-warning]="isRangeModified"
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="60" fxLayoutAlign="start center" fxLayout="row">
              <strong *ngIf="!productSelectedInList(true)" class="text-center" [ngClass.lt-sm]="{'card-title': true}">select products</strong>
              <strong *ngIf="productSelectedInList(true)" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{ getProductsSelected(true) }}</span> products selected</strong>
            </div>
            <div fxFlex="40" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <button *ngIf="isRangeModified"
                  mat-icon-button color="primary"
                  matTooltip="Save Product Range"
                  aria-label="Save Product Range"
                  (click)="updateProductRange()">
                  <mat-icon>done</mat-icon>
                </button>
                <button *ngIf="productSelectedInList(true)"
                  mat-icon-button color="basic"
                  matTooltip="Cancel Select"
                  aria-label="Cancel Select"
                  (click)="clearAllSelectedProducts(true)">
                  <mat-icon>clear</mat-icon>
                </button>
                <button
                  mat-icon-button color="accent"
                  matTooltip="Select All Products"
                  aria-label="Select All Products"
                  (click)="selectAllProducts(true)">
                  <mat-icon>done_all</mat-icon>
                </button>
                <button *ngIf="productSelectedInList(true)"
                  mat-icon-button color="warn"
                  matTooltip="Remove Product(s) from Range"
                  aria-label="Remove Product(s) from Range"
                  (click)="transferList(true)">
                  <mat-icon fxShow fxHide.lt-sm>keyboard_double_arrow_right</mat-icon>
                  <mat-icon fxShow fxHide.gt-sm>keyboard_double_arrow_down</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <div fxLayout="row wrap" fxLayoutAlign="center start">
          <div *ngFor="let item of inRange">
            <thumb-product-card cdkDrag
              [isSituUser]="isSituUser"
              [selectedCompanyId]="selectedCompany?.id"
              [cdkDragDisabled]="shareMode"
              [item]="item"
              [isCatalog]="false"
              [selected]="item.selected"
              (click)="selectProduct(item)"
              [situView]="situViewUrl"
              [companyName]="getCompanyName(item?.companyId) | async"
              [companyLogo]="getCompanyLogo(item?.companyId) | async">
            </thumb-product-card>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div fxFlex.gt-sm="50" fxFlex.gt-xs="100" fxFlex="100">
    <mat-card>
      <mat-card-content id="outRangeContainer" cdkDropList [cdkDropListData]="outRange" (cdkDropListDropped)="drop($event)" cdkDropListConnectedTo="inRangeContainer">
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label *ngIf="!shareMode"><span class="text-info">{{ getProducts(false) }}</span> products available</label>
          <label *ngIf="shareMode"><strong>{{ rangeName }}</strong> range shared with <span class="text-info">{{ basePartnershipIds?.length }}</span> partners</label>
        </div>
        <ng-container *ngIf="!shareMode">
          <mat-card class="banner-incomplete" 
          [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row-reverse" fxLayout.lt-sm="column">
            <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row">
              <strong *ngIf="!productSelectedInList(false)" class="text-center" [ngClass.lt-sm]="{'card-title': true}">select products</strong>
              <strong *ngIf="productSelectedInList(false)" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{ getProductsSelected(false) }}</span> products selected</strong>
            </div>
            <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
              <div fxLayoutAlign="end center" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse" fxLayoutAlign.lt-sm="center center" class="date-text">
                <button *ngIf="productSelectedInList(false)"
                  mat-icon-button color="basic"
                  matTooltip="Cancel Select"
                  aria-label="Cancel Select"
                  (click)="clearAllSelectedProducts(false)">
                  <mat-icon>clear</mat-icon>
                </button>
                <button
                  mat-icon-button color="accent"
                  matTooltip="Select All Products"
                  aria-label="Select All Products"
                  (click)="selectAllProducts(false)">
                  <mat-icon>done_all</mat-icon>
                </button>
                <button *ngIf="productSelectedInList(false)"
                  mat-icon-button color="primary"
                  matTooltip="Add Product(s) to Range"
                  aria-label="Add Product(s) to Range"
                  (click)="transferList(false)">
                  <mat-icon fxShow fxHide.lt-sm>keyboard_double_arrow_left</mat-icon>
                  <mat-icon fxShow fxHide.gt-sm>keyboard_double_arrow_up</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <div fxLayout="row wrap" fxLayoutAlign="center start">
          <ng-container *ngFor="let item of outRange; let i = index;">
            <thumb-product-card cdkDrag *ngIf="i < pageLength"
              [cdkDragDisabled]="shareMode"  
              [isSituUser]="isSituUser"
              [selectedCompanyId]="selectedCompany?.id"
              [item]="item"
              [isCatalog]="false"
              [selected]="item.selected"
              (click)="selectProduct(item)"
              [situView]="situViewUrl"
              [companyName]="getCompanyName(item?.companyId) | async"
              [companyLogo]="getCompanyLogo(item?.companyId) | async">
            </thumb-product-card>
          </ng-container>
          <div #showMoreProductsMarker fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
            <button *ngIf="hasMoreProductsToShow()" mat-flat-button color="accent" (click)="showMoreProducts()">Show more products</button>
        </div>
        </div>
        </ng-container>
        <ng-container *ngIf="shareMode">
          <mat-card class="banner-incomplete" 
            [ngClass.lt-lg]="{'mat-card-inline-sm': true}"
            [class.banner-incomplete]="!isPartnershipModified"
            [class.banner-warning]="isPartnershipModified">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row-reverse" fxLayout.lt-sm="column">
              <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row">
                <strong *ngIf="!partnershipSelectedInList(false)" class="text-center" [ngClass.lt-sm]="{'card-title': true}">select partners</strong>
                <strong *ngIf="partnershipSelectedInList(false)" class="text-center" [ngClass.lt-sm]="{'card-title': true}"><span class="text-info">{{ getPartnershipsSelected() }}</span> partners selected</strong>
              </div>
              <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
                <div fxLayoutAlign="end center" fxLayout="row-reverse" fxLayout.lt-sm="column-reverse" fxLayoutAlign.lt-sm="center center" class="date-text">
                  <button *ngIf="isPartnershipModified"
                    mat-icon-button color="primary"
                    matTooltip="Save Changes to Partner Shares"
                    aria-label="Save Changes to Partner Shares"
                    (click)="updateProductRangeAuthorisedCompany()">
                    <mat-icon>share</mat-icon>
                  </button>
                  <button *ngIf="partnershipSelectedInList()"
                    mat-icon-button color="basic"
                    matTooltip="Cancel Select"
                    aria-label="Cancel Select"
                    (click)="clearAllSelectedPartners()">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button
                    mat-icon-button color="accent"
                    matTooltip="Select All Partners"
                    aria-label="Select All Partners"
                    (click)="selectAllPartners()">
                    <mat-icon>done_all</mat-icon>
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          <div *ngFor="let item of partnerships">
            <partnership-card
              [item]="item"
              [companyId]="selectedCompany?.id"
              [readonly]="true"
              [selected]="item.selected"
              (click)="selectPartner(item)">
            </partnership-card>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>
